import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderById } from '@models';
import { getOrderDistrict } from '@utils';
import { ButtonCustomSizeConfig } from 'nanaykuna-ui-kit/loader';

// Figma 7767:9139 — product columns of the inline detail. Prices and the
// order total are not shown to any seller.
const PRODUCT_HEADS = ['Código SKU', 'Productos', 'Cantidad', 'UM'];

// Figma I7767:9315: "Ver más" is a 100×32 pill with a 10/500 label — no kit
// size alias pairs that height with that text.
const VIEW_MORE_SIZE_CONFIG: ButtonCustomSizeConfig = {
  height: 32,
  paddingX: 12,
  textType: 'p10',
  iconSize: 16,
};

@Component({
  selector: 'digicem-order-detail-card',
  templateUrl: './order-detail-card.component.html',
  styleUrls: ['./order-detail-card.component.scss'],
})
export class OrderDetailCardComponent {
  @Input() order: OrderById | undefined;
  @Input() alias: string | null | undefined;
  @Output() goToDetail: EventEmitter<void> = new EventEmitter<void>();
  @Output() collapseContent: EventEmitter<void> = new EventEmitter<void>();

  protected readonly productHeads = PRODUCT_HEADS;
  protected readonly viewMoreSizeConfig = VIEW_MORE_SIZE_CONFIG;

  protected get district(): string {
    return this.order ? getOrderDistrict(this.order) : '';
  }

  protected goDetail(): void {
    if (this.order) {
      this.goToDetail.emit();
    }
  }

  protected collapse(): void {
    this.collapseContent.emit();
  }
}
